
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { connect, getIn } from "formik";

const OzDateTimePicker = connect(({
    label,
    name,
    placeholder,
    formik,
    disableField = false,
    disablePast = true,
    onlyDateTimeMenu = false,
    format = "YYYY-MM-DD HH:mm:ss",
    ...additionalProps
}) => {
    const values = getIn(formik.values, name);
    let error = getIn(formik.errors, name);
    error = error ? error === "Holiday Date is required" ? error : "Holiday Date is invalid" : null;
    console.log('error', error)
    const touch = getIn(formik.touched, name);
    const parsedDate = values ? dayjs(values) : null;
    const date = parsedDate?.isValid?.() ? parsedDate : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Typography htmlFor={name} fontSize='12px' fontWeight={400} lineHeight='14px' marginBottom={'6px'} marginLeft='1px' color={disableField ? '#99A0A8' : '#212121'}>
                {label}
            </Typography>
            <DateTimePicker
                disabled={disableField}
                value={date}
                onChange={(newValue) => {
                    let newFormattedValue = newValue?.isValid?.() ? newValue.format(format) : null;
                    formik.setFieldValue(name, newFormattedValue)
                }}
                disablePast={disablePast}
                minDateTime={disablePast ? dayjs() : undefined}
                openTo="day"
                showToolbar={false}
                inputFormat={format}
                {...additionalProps}
                renderInput={(params) => <TextField
                    id={name}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#ffff',
                            fontSize: '14px',
                            height: '44px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: '1px solid #D6D6D7'
                        },
                        '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                            border: '1px solid #D6D6D7'
                        }
                    }}
                    fullWidth
                    onBlur={formik.handleBlur}
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        readOnly: onlyDateTimeMenu,
                        endAdornment: (
                            <>
                                {onlyDateTimeMenu && Boolean(date) && !disableField && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{ height: "24px", width: "24px" }}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                formik.setFieldValue(name, null);
                                            }}
                                            size="small"
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )}
                                {params.InputProps?.endAdornment}
                            </>
                        ),
                    }}
                    inputProps={{
                        ...params.inputProps,
                        readOnly: onlyDateTimeMenu,
                    }}
                    error={Boolean(touch) && Boolean(error)}
                    helperText={touch && error}
                />}
            />
        </LocalizationProvider >
    );
})

export default OzDateTimePicker
